import { armorAPI } from '~/services/api';

function fetchShippingOptions() {
  return armorAPI.request({
    method: 'GET',
    url: `service-groups`,
  });
}

function updateShippingOption(payload: unknown) {
  return armorAPI.request({
    method: 'PUT',
    url: `service-groups`,
    data: payload,
  });
}

function createShippingOption(payload: unknown) {
  return armorAPI.request({
    method: 'POST',
    url: `service-groups`,
    data: payload,
  });
}

function deleteShippingOption(id: string) {
  return armorAPI.request({
    method: 'DELETE',
    url: `service-groups/${id}/`,
  });
}

function getliveRatePackage() {
  return armorAPI.request({
    method: 'GET',
    url: `live-rates/settings/parcel-template`,
  });
}

function updateLiveRatePackage(payload: { object_id: string }) {
  return armorAPI.request({
    method: 'PUT',
    url: `live-rates/settings/parcel-template`,
    data: payload,
  });
}

function fetchLiveRateSenderAddress() {
  return armorAPI.request({
    method: 'GET',
    url: `live-rates/settings/address`,
  });
}

function updateLiveRateSenderAddress(liveRateAddressId: number) {
  const payload = { live_rates_address_id: liveRateAddressId };
  return armorAPI.request({
    method: 'PUT',
    url: `live-rates/settings/address`,
    data: payload,
  });
}

export {
  fetchShippingOptions,
  updateShippingOption,
  createShippingOption,
  deleteShippingOption,
  getliveRatePackage,
  updateLiveRatePackage,
  fetchLiveRateSenderAddress,
  updateLiveRateSenderAddress,
};
